import { render } from "./Person.vue?vue&type=template&id=925802e2"
const script = {}
script.render = render

export default script